import "react-native-gesture-handler";
import React, { Component } from "react";
import {
  StyleSheet,
  View,
  ScrollView,
  Platform,
  Dimensions,
  StatusBar,
  SafeAreaView,
  NativeModules,
  NativeEventEmitter,
} from "react-native";
import * as ExpoSplashScreen from "expo-splash-screen";
import { createAppContainer } from "react-navigation";
const axios = require("axios").default;
import * as Font from "expo-font";
import Navigator from "./src/navigation/navigator";
// === Redux ===
import { Provider } from "react-redux";
import * as Actions from "./src/actions/_ActionTypes";
// === Components ===
import Text from "./src/components_v2/TextFont";
import * as SecureStore from "./src/components_v2/DeviceAsyncStorage";
import DoorbellAlert from "./src/components_v2/DoorbellAlert";
import AppLog from "./src/logger";
import ConnectionChecker from "./src/components_v2/ConnectionChecker";
// === Modules ===
import FirebaseHandler from "./src/modules/firebaseHandler/FirebaseHandler";
// === Assets ===
import * as CONSTS from "./assets/consts";
import Theme from "./src/argon-ui/Theme";
import { IS_WEB, translate } from "./src/locales/translate";
// === Screens ===
import SplashScreen from "./src/screens_v2/SplashScreen";
import MessageToast from "./src/components_v2/MessageToast";
import Wrapper from "./Wrapper";
import IPCameraHelper from "./src/modules/cameraHelper/IPCameraHelper";
import { getDir } from "./src/util";

const SCREEN_WIDTH = Dimensions.get("screen").width;
const earlyLogs = [];
const AppContainer = createAppContainer(Navigator);
if (!IS_WEB) {
  new FirebaseHandler().setBackgroundMessageHandler();
}

class App extends Component {
  constructor(props) {
    super(props);
    this.socket = null;
    this.eventListener = null;
    this.state = {
      testUrl: "https://app.taplife.ir/updates?platform=web", // "http://apple.com",
      error: undefined,
      // isStarting : true,
      showSplashScreen: true, // change to 'true' to see splash screen
      message: translate("splash.searchingNetwork"),
      serverUrl: "",
      access_token: "",
      userFullName: "",
      expoPushToken: "",
      errors: ["errors"],
      showErrors: false,
    };
  }
  TLStore;
  doorbellHandler = {
    handle: undefined,
  };

  initData = (token, buildingId = null) => {
    //* all INIT requests moved to socketMiddleware_socketHandler.onForceInit()
    this.TLStore.dispatch({
      type: Actions.FORCE_INIT,
      payload: { buildingId },
      socket: { send: true, keepSocket: true },
    });

    /* get firebase token */
    try {
      if (Platform.OS === "ios" || Platform.OS === "android") {
        // this.setState({ errors: [...this.state.errors, "try fetch firebase token"] })
        var firebaseHandler = new FirebaseHandler();
        firebaseHandler
          .requestPermission()
          .then((enabled) => {
            if (enabled) {
              firebaseHandler
                .getToken()
                .then((pushToken) => {
                  this.TLStore.dispatch({
                    type: "USER_UPDATE_PUSH_NOTIFICATION_TOKEN",
                    payload: { token: pushToken },
                    socket: { send: true, keepSocket: true },
                    accessToken: this.state.access_token || token,
                  });

                  this.setState({ expoPushToken: pushToken });

                  // var _error = "valid token = " + pushToken;
                  // this.setState({ errors: [...this.state.errors, _error] })
                })
                .catch((e) => {
                  var _error = JSON.stringify(e);
                  this.setState({ errors: [...this.state.errors, _error] });
                });
            }
          })
          .catch((error) => {
            this.setState({
              errors: [
                ...this.state.errors,
                `request firebase message permission error: ${JSON.stringify(
                  error
                )}`,
              ],
            });
            // User has rejected permissions
          });
      }
    } catch (e) {
      console.log("failed to getDevicePushTokenAsync", e);
      var httpClient = axios.create();
      var _error = "error on getDevicePushTokenAsync . " + JSON.stringify(e);
      AppLog(httpClient, this.state.serverUrl, _error, "ERROR", 0);
      this.setState({ errors: [...this.state.errors, _error] });
    }
    this.setState({ showSplashScreen: false, message: "" });
  };
  registerForPushNotification = async () => {
    try {
      var firebaseHandler = new FirebaseHandler();
      firebaseHandler.createDefaultChannels();
      firebaseHandler.registerForPushNotificationListeners();
    } catch (error) {
      console.log("error on App.registerForPushNotification", error);
      // this.setState({
      //   errors: [...this.state.errors, JSON.stringify(error)],
      // });
    }
  };
  handleDoorbellNotification = async (notification) => {
    console.log("notification", notification);

    let cameraId = undefined;
    if (notification && notification.data && notification.data.cameraId) {
      cameraId = notification.data.cameraId;
    }

    console.log("handling doorbell in App.js with cameraId", cameraId);
    let serverUrl = await SecureStore.getItemAsync(CONSTS.SERVER_URL);
    let access_token = await SecureStore.getItemAsync(CONSTS.ACCESS_TOKEN);

    var cameraGetInfoUrl = `${serverUrl}Camera/V380Info/${cameraId}`;

    fetch(cameraGetInfoUrl, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_token}`,
      },
    })
      .then((res) => {
        if (res.status == 200) {
          return res.json();
        } else return { status: res.status };
      })
      .then((resj) => {
        if (resj.result && resj.camera) {
          let { cameraId, friendlyName, ip, port, userName, password } =
            resj.camera;

          if (cameraId && ip && port && userName && password) {
            var camHelper = new IPCameraHelper();
            camHelper.play(
              friendlyName,
              ip,
              port,
              cameraId,
              userName,
              password,
              true, // hasDoorLock
              serverUrl,
              access_token
            );
          }
        }
      })
      .catch(console.log);
  };
  async componentDidMount() {
    // let result = await Permissions.askAsync(Permissions.NOTIFICATIONS);
    // console.log("result Permission", result);
    Font.loadAsync({
      IRANSansWebFaNum: require("./assets/fonts/IRANSansWeb_FaNum.ttf"),
      FontAwesomeProLight: require("./assets/fonts/fa6ProLight.ttf"),
      FontAwesomeProRegular: require("./assets/fonts/fa6ProRegular.ttf"),
    })
      .then(() => {
        ExpoSplashScreen.hideAsync();
      })
      .catch((e) => {
        console.log("error on load fonts", e);
        ExpoSplashScreen.hideAsync();
      });
    this.setState({ errors: [...this.state.errors, ...earlyLogs] });
    if (Platform.OS != "web") {
      this.registerForPushNotification();
      // this.initLocalNotifications();
    }
    this.doorbellHandler.handle = (notification) => {
      // console.log("notification", notification);
      // console.log("doorbellHandler.handle bind method", notification?.data);
      try {
        // if (notification) {
        this.handleDoorbellNotification(notification)
          .then()
          .catch((e) => console.log("doorbellHandler error", e));
        // }
      } catch (e) {
        console.log(e);
      }
    };
    // listen to native events (door unlock event)
    // listener unsubscribed in ComponentWillUnMount
    const eventEmitter = new NativeEventEmitter(NativeModules.IPCameraHelper);
    this.eventListener = eventEmitter.addListener(
      "onV380CameraUnlockPressed",
      (cameraId) => {
        console.log(
          `v380 camera request for unlock door for camera ${cameraId}. event fired in App.componentDidMount()`
        );
      }
    );

    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", this.onBackButtonEvent);
  }
  onBackButtonEvent = (e) => {
    e.preventDefault();
    window.history.pushState(null, null, window.location.pathname);
    this.isBackButtonClicked = false;
    return;
    if (window.confirm(translate("app.doYouConfirmLogout"))) {
      this.isBackButtonClicked = false;
    } else {
      window.history.pushState(null, null, window.location.pathname);
      this.isBackButtonClicked = false;
    }
  };

  componentWillUnmount() {
    window.removeEventListener("popstate", this.onBackButtonEvent);
    console.log("app will un mount App");
    // unsubscribe event listener from native part (doorbell unlock)
    // this.eventListener.remove();
  }

  handleCallBackShowSplashScreen = (childData) => {
    this.setState({ showSplashScreen: childData });
  };

  render() {
    if (this.TLStore && !this.state.showSplashScreen) {
      return (
        <Provider store={this.TLStore}>
          <Wrapper>
            <SafeAreaView
              style={[
                Platform.OS === "web" || Platform.OS == "ios"
                  ? {
                      // maxWidth: Math.min(SCREEN_WIDTH, WEB_MAX_WIDTH),
                      borderColor: "transparent",
                      backgroundColor: Theme.COLORS.PRIMARY,
                      borderBottomWidth: 1, //**IMPORTANT: do not remove border. using transparent border will fix screen height and will fix bottom navigation.
                      flex: 1,
                    }
                  : { flex: 1, maxWidth: SCREEN_WIDTH },
                { direction: getDir() },
              ]}
            >
              <StatusBar
                barStyle="light-content"
                backgroundColor={Theme.COLORS.PRIMARY}
              />
              {this.state.showErrors && (
                <ScrollView style={{ marginHorizontal: 10, height: 50 }}>
                  {this.state.errors.map((e, i) => {
                    return <Text key={i}>{e}</Text>;
                  })}
                </ScrollView>
              )}
              <AppContainer screenProps={{ translate }} />
              <ConnectionChecker
                prevState={this.state.showSplashScreen}
                parentCallBack={this.handleCallBackShowSplashScreen}
              />
              <DoorbellAlert />
              <MessageToast />
            </SafeAreaView>
          </Wrapper>
        </Provider>
      );
    } else if (this.state.showSplashScreen) {
      return (
        <Wrapper>
          <SplashScreen
            useBullet={false}
            onStore={(TLStore, serverUrl) => {
              this.setState({ serverUrl });
              this.TLStore = TLStore;
              this.setState({ showSplashScreen: false });
            }}
          />
        </Wrapper>
      );
    } else {
      return (
        <View>
          <Text>empty screen</Text>
        </View>
      );
    }
  }
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
    alignItems: "center",
    justifyContent: "center",
  },
});

export default App;
